import type {TranslationFunction} from 'components/translation/utils';
import Swal from 'sweetalert2';

export const alertError = (error: Error, t: TranslationFunction) => {
  Swal.fire({
    icon: 'error',
    title: t('Failed to save to server'),
    position: 'top-end',
    text: error.message,
  });
};
